import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { NumeroDocumentoInput } from 'sharedComponents/inputs/text'

import { KeyEventUtil } from 'utils'

const NumeroDocumentoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('select-forminformnotcreddeb-tipoDocumento', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='N° DOC' htmlFor='input-infonota-numeroDocumento' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='numeroDocumento'>
          {({ field }) => (
            <NumeroDocumentoInput
              {...field}
              id='input-infonota-numeroDocumento'
              disabled={fIsSubmitting}
              isInvalid={iError && iTouched}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NumeroDocumentoFormGroup)
